export default function DotsLoading() {
    return (
        <div className="flex justify-center py-[6px]">
            <div className="dot-flashing"></div>
        </div>
    )
}